





















import mixins from 'vue-typed-mixins'
import { generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { ALL_LANG_KEY, language_t } from '@/store/modules/pref'
import VueI18n from 'vue-i18n'

interface LangRow {
  key: string
  nativeName: string
}
export default mixins(generalDialogMixin).extend({
  computed: {
    show (): boolean {
      console.log('=====', this.$route.name)
      return this.$route.name === 'sys_ui_lang' || true
    },
    curLang (): language_t { return this.$s.$state.pref.global.lang },
    langList (): LangRow[] {
      return ALL_LANG_KEY.map(k => ({
        key: k,
        nativeName: this.$t('langName', k) as string
      }))
    },
  },
  methods: {
    selectLang (key: language_t) {
      this.$s.pref.mutations.assignLang(key)
      this.closeThisDialog()
    }
  }
})
